import { Message } from 'lib-shared-legacy-types';

/**
 * The messages come sorted by created_at from dynamo, but, after introducting
 * redacting, we will have multiple messages with the same created_at. In this
 * case we want to show the anonymized messages first
 */
export const sortMessages = (a: Message, b: Message) => {
  if (!a.created_at) {
    if (!b.created_at) {
      return 0;
    }
    return -1;
  }
  if (!b.created_at) {
    return 1;
  }
  if (a.created_at < b.created_at) {
    return -1;
  }
  if (a.created_at > b.created_at) {
    return 1;
  }
  if (!a.anonymized_at) {
    if (!b.anonymized_at) {
      return 0;
    }
    return 1;
  }
  if (!b.anonymized_at) {
    return -1;
  }
  return a.anonymized_at.localeCompare(b.anonymized_at);
};
